import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sys/user/list',
    method: 'get',
    params: params
  })
}

export function getObj (id) {
  return axios({
    url: '/sys/user/info/' + id,
    method: 'get'
  })
}

export function addObj (obj) {
  return axios({
    url: '/sys/user/save',
    method: 'POST',
    data: obj
  })
}

export function putObj (obj) {
  return axios({
    url: '/sys/user/update',
    method: 'POST',
    data: obj
  })
}

export function delObj (id) {
  return axios({
    url: '/sys/user/delete/' + id,
    method: 'GET'
  })
}

export function dropDownByCode (params) {
  return axios({
    url: '/sys/user/dropDownByCode',
    method: 'get',
    params: params
  })
}

// 所有用户下拉框
export function userDropDown () {
  return axios({
    url: '/sys/user/userDropDown',
    method: 'Get'
  })
}
// 个人信息修改
export function edit (obj) {
  return axios({
    url: '/sys/user/edit',
    method: 'POST',
    data: obj
  })
}
